/**
 * 
 * 
 * 
 */
export default class InventoryAvailable extends HTMLElement {

    constructor() {
        super();
        this.variantId = null;
        this.attachShadow({ mode: 'open' }); // Attach a shadow root to the element
        this.shadowRoot.innerHTML = `
            <style>
                .dynamic-flex-overflow {
                    display: flex;
                    flex-wrap: wrap;
                }
                
                .dynamic-flex-overflow .controler {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: var(--bg-color-light-grey);
                    height: fit-content;
                    aspect-ratio: 1;
                    align-self: center;
                }
                
                .dynamic-flex-overflow.showing-more .show-more {
                    display: none;
                }
                
                .dynamic-flex-overflow:not(.showing-more) .show-less {
                    display: none;
                }
                
                .dynamic-flex-overflow:not(.is-full) .controler {
                    display: none;
                }
                
                .dynamic-flex-overflow:not(.showing-more) .dynamic-overflow-element.extra-element {
                    display: none;
                }
            </style>
        `
        this.inventoryElement = document.createElement("content");
        this.shadowRoot.appendChild(this.inventoryElement);
    }

    connectedCallback() {
        var productReference = document.getElementById("product_reference");
        var selectElement = document.querySelector('[name="id"]');
        var selfVariantId = this; 

        function handleVariantChange() {
            var selectedValue = selectElement.value;
            
            // Obtener el índice de la opción seleccionada
            var selectedIndex = selectElement.selectedIndex;
            var selectedOption = selectElement.options[selectedIndex];
            var selectedInfo = selectedOption.textContent;

            selfVariantId.getInventoryAvailableContent(selectedInfo, productReference.value);
        }
        selectElement.addEventListener('change', handleVariantChange);
        handleVariantChange();

    }

    disconnectedCallback() {
        // Clear the interval when the element is removed from the DOM
        clearInterval(this.interval);
    }

    async getInventoryAvailableContent(sizeSelected, productReference) {
        let language = Shopify.locale;
        let fetchRes = await fetch(`https://bikila.tible.tech/inventory-available?size_selected=${sizeSelected}&product_reference=${productReference}&lang=${language}`);
        console.log(`https://bikila.tible.tech/inventory-available?size_selected=${sizeSelected}&product_reference=${productReference}&lang=${language}`);
        let body     = await fetchRes.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(body, 'text/html');
        this.inventoryElement.innerHTML = ``;
        this.inventoryElement.appendChild(htmlDoc.querySelector("#parsed-variant-html"));
    }


    /**
     * 
     * Función de ayuda para simplificar la creación de Nodos
     * 
     * @param {String} type Tipo de nodo a crear
     * @param {String[Array]} classArray Clases que queremos añadir a nuestro elemento
     * @param {Object} options Opciones extra a añadir a nuestro elemento
     * @returns 
     */
    createNode(type, classArray = [], options = {}) {
        let node = document.createElement(type);
        // Asignamos todas las características de nuestro objeto al nodo creado 
        for (let [optionKey, optionValue] of Object.entries(options)) {
            node[optionKey] = optionValue;
        }
        
        // Asignamos las clases controlando errores
        classArray.map(singleClass => {
            try {
            node.classList.add(singleClass); 
            } catch (error) {
                console.warn(node, `Could not add the class ${singleClass} to the classList node`);
            }
        });      
        return node;
    }

}

if (!customElements.get('inventory-available')) {
    customElements.define('inventory-available', InventoryAvailable);
}